import { styled, Box, Flex, selectTheme } from '@creditas-ui/react';

const Overlay = styled(Box)`
  width: 100vw;
  height: calc(100% - 60px);
  position: fixed;
  top: 60px;
  z-index: 10;
  background: ${selectTheme('colors.neutral.0')};
`;

const Modal = styled(Flex)`
  background: ${selectTheme('colors.neutral.10')};
  border-radius: 20px 20px 0px 0px;
  height: 100%;
  padding: 64px 40px 40px;
  box-sizing: border-box;
  flex-direction: column;
  justify-content: space-between;
  overflow-y: scroll;
`;

export { Overlay, Modal };
